var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("筛选查询")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "仓库" },
                                        model: {
                                          value: _vm.form.origin,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "origin", $$v)
                                          },
                                          expression: "form.origin"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { value: 0, label: "全部" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.storehouseIds, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.key
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "波次号" },
                                        model: {
                                          value: _vm.search_type,
                                          callback: function($$v) {
                                            _vm.search_type = $$v
                                          },
                                          expression: "search_type"
                                        }
                                      },
                                      _vm._l(_vm.search_options, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: {
                                      "margin-left": "-15px",
                                      width: "165px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "请输入搜索内容" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.search_value,
                                        callback: function($$v) {
                                          _vm.search_value = $$v
                                        },
                                        expression: "search_value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "工单状态" },
                                        model: {
                                          value: _vm.form.handle_status,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "handle_status",
                                              $$v
                                            )
                                          },
                                          expression: "form.handle_status"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-option",
                                          { attrs: { value: "" } },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.handle_status, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.value,
                                              value: item.key
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "快递公司" },
                                        model: {
                                          value: _vm.form.shipping_company,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "shipping_company",
                                              $$v
                                            )
                                          },
                                          expression: "form.shipping_company"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-option",
                                          { attrs: { value: "" } },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.conditionData.shipping_company,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item,
                                              attrs: {
                                                label: item,
                                                value: item
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "拆包状态" },
                                        model: {
                                          value: _vm.form.is_exception,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "is_exception",
                                              $$v
                                            )
                                          },
                                          expression: "form.is_exception"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-option",
                                          { attrs: { value: "" } },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.cb_status, function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.value,
                                              value: item.key
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "500px" },
                                    attrs: { label: "提交时间：" }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "default-time": ["06:00:00", "06:00:00"]
                                      },
                                      model: {
                                        value: _vm.form.create_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "create_time", $$v)
                                        },
                                        expression: "form.create_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "500px" },
                                    attrs: { label: "拆包时间：" }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "default-time": ["06:00:00", "06:00:00"]
                                      },
                                      model: {
                                        value: _vm.form.back_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "back_time", $$v)
                                        },
                                        expression: "form.back_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "el-row",
            [
              _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      background: "#f3f3f3",
                      height: "50px",
                      "line-height": "30px",
                      padding: "0 25px",
                      display: "flex",
                      "align-items": "center"
                    }
                  },
                  [
                    _c("div", [_vm._v("数据列表：")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "auto" },
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.output }
                      },
                      [_vm._v("导出")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.resData
                  ? _c(
                      "div",
                      { staticStyle: { "margin-bottom": "0" } },
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading"
                              }
                            ],
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              height: "600",
                              data: _vm.resData.list,
                              "tooltip-effect": "dark"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "id",
                                label: "工单id",
                                width: "120",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_img",
                                label: "商品图片",
                                width: "120",
                                "show-overflow-tooltip": "",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "viewer",
                                                rawName: "v-viewer"
                                              }
                                            ],
                                            staticStyle: {
                                              width: "40px",
                                              height: "40px",
                                              overflow: "hidden",
                                              cursor: "pointer",
                                              display: "inline-block"
                                            }
                                          },
                                          _vm._l(scope.row.imgs, function(
                                            item,
                                            index
                                          ) {
                                            return _c("img", {
                                              key: index,
                                              staticStyle: {
                                                width: "100%",
                                                height: "100%"
                                              },
                                              attrs: { src: item }
                                            })
                                          }),
                                          0
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2800175986
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_no",
                                label: "货号",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "颜色/尺码/件数",
                                "show-overflow-tooltip": "",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(scope.row.co_val) +
                                            "/" +
                                            _vm._s(scope.row.si_val) +
                                            "/" +
                                            _vm._s(scope.row.goods_number) +
                                            "\n            "
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1784407143
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_lib_origin",
                                label: "发货地",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "service_order_handle_status",
                                label: "工单状态",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "shipping_num",
                                label: "快递单号",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "shipping_company",
                                label: "快递公司",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "user_id",
                                label: "用户id",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "consignee",
                                label: "收件人姓名",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "out_time",
                                label: "出库日期",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "update_time",
                                label: "拒签登记时间",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "cb_status",
                                label: "拆包状态",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "admin_name",
                                label: "拆包人",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "back_time",
                                label: "拆包时间",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "dbids",
                                label: "打标id",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "dbid_note",
                                label: "打标备注",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "out_shipping_time",
                                label: "日志",
                                "show-overflow-tooltip": "",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                return _vm.showLogList(
                                                  scope.row.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("\n                查看")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                153983339
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                fixed: "right",
                                label: "操作",
                                "show-overflow-tooltip": "",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        scope.row.goods_number !=
                                        scope.row.c_num
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleDetail(
                                                      scope.row.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                拆包\n              "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2181621998
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resData
                  ? _c(
                      "div",
                      {
                        staticStyle: { "text-align": "right", padding: "25px" }
                      },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.curPage,
                            background: "",
                            layout: "total, prev, pager, next, jumper ,sizes",
                            total: _vm.resData.count,
                            "page-size": _vm.form.pagesize,
                            "page-sizes": [50, 100, 200, 500, 1000]
                          },
                          on: {
                            "update:currentPage": function($event) {
                              _vm.curPage = $event
                            },
                            "update:current-page": function($event) {
                              _vm.curPage = $event
                            },
                            "current-change": _vm.handleCurrentChange,
                            "size-change": _vm.handleSizeChange
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShow
        ? _c(
            "div",
            [
              _c("un-package", {
                attrs: { work_id: _vm.work_id },
                on: { onCloseDialog: _vm.onCloseDialog }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showLog
        ? _c(
            "div",
            [
              _c("work-log", {
                attrs: { work_id: _vm.work_id },
                on: { onCloseDialog: _vm.onCloseDialog }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f430985", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f430985","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cod/denyList.vue
// module id = null
// module chunks = 